import React from "react";
import AddStudents from "./AddStudents";
import ListStudents from "./ListStudents";

const AddStudentToBatch = ({ batchName }) => {
  return (
    <>
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        <div className="container mx-auto px-6 py-3">
          <h3 className="text-gray-700 text-3xl font-bold">
            Manage Students for {batchName}
          </h3>
          <AddStudents />
          <hr />
          <div className="mt-3">
            <h1 className="mb-2 text-xl font-bold">
              List of Students of batch {batchName}
            </h1>
            <ListStudents />
          </div>
        </div>
      </main>
    </>
  );
};

export default AddStudentToBatch;
